import Vue from 'vue'
import Vuex from 'vuex'
import { Toast } from 'vant';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
     area:'',//地址信息
     serviceTags:[],//标签信息
     showTipsModal:false,//是否展示自学时间弹框
     canSelfLearn:true,//是否能自学
     token:'',
     statusHeight:0,
     refreshPage:false,//
  },
  getters: {
    //获取Token
    "GET_TOKEN": function (state) {      
      if (!state.token) {  
          state.token = localStorage.getItem("token");
      }      
      return state.token;    
  },
  },  
  mutations: {    

    Set_ModalVisible(state,options){     
      state.showTipsModal=options
    },
    Set_CanLearn(state,options){
      state.canSelfLearn=false
    },
    SET_Height(state,options){
      state.statusHeight=options
    },
    Set_refresh(state,options){
      // Toast(options+'')
      state.refreshPage=options
    },
    // Set_Token(state,options){
    //   state.token.options
    // },
     // 存储token
     "SET_TOKEN" (state, value) {
      state.token = value;
      localStorage.setItem("token", value);
  },
  //删除token
  "REMOVE_TOKEN" (state) {
      state.token = null;      
      localStorage.removeItem("token");
  },
  },
  actions: {
     
  }
})
